import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { ErrorCard } from '@anyx/shared-ui';

/**
 * Standalone error page - no provider dependencies needed.
 * Recreates NotFoundMessage functionality with native Link (no Mantine/ThemeProvider required).
 */
export const ErrorNotFoundPage = () => {
  const { t } = useTranslation('shared');

  return (
    <div className="w-full p-4 lg:p-0">
      <ErrorCard
        title={t('shared.notFound.title')}
        guideline={t('shared.notFound.guideline')}
        content={
          <Link
            to="/"
            className="bg-blue-6 text-2xs hover:bg-blue-7 inline-flex h-8 items-center justify-center rounded-sm px-6 font-semibold text-white transition-colors"
          >
            {t('shared.button.home')}
          </Link>
        }
      />
    </div>
  );
};
